/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Webplatform-ts V3 API
 * OpenAPI spec version: 3.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  V3RewardsAccessState,
  V3RewardsRate,
  V3RewardsSummary
} from '../../model';

import { webplatformProxyInstance } from '../../../../../lib/integrations/axios.ts';
import type { ErrorType } from '../../../../../lib/integrations/axios.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns whether the authenticated organization is eligible for, enrolled in, or excluded from Rewards.
 * @summary Get the organization's rewards gate state
 */
export const getV3RewardsAccess = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<V3RewardsAccessState>(
      {url: `/v3/rewards/access`, method: 'GET', signal
    },
      options);
    }




export const getGetV3RewardsAccessQueryKey = () => {
    return [
    `/v3/rewards/access`
    ] as const;
    }


export const getGetV3RewardsAccessQueryOptions = <TData = Awaited<ReturnType<typeof getV3RewardsAccess>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsAccess>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3RewardsAccessQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3RewardsAccess>>> = ({ signal }) => getV3RewardsAccess(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3RewardsAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getV3RewardsAccess>>>
export type GetV3RewardsAccessQueryError = ErrorType<unknown>


export function useGetV3RewardsAccess<TData = Awaited<ReturnType<typeof getV3RewardsAccess>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3RewardsAccess>>,
          TError,
          Awaited<ReturnType<typeof getV3RewardsAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3RewardsAccess<TData = Awaited<ReturnType<typeof getV3RewardsAccess>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3RewardsAccess>>,
          TError,
          Awaited<ReturnType<typeof getV3RewardsAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3RewardsAccess<TData = Awaited<ReturnType<typeof getV3RewardsAccess>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsAccess>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the organization's rewards gate state
 */

export function useGetV3RewardsAccess<TData = Awaited<ReturnType<typeof getV3RewardsAccess>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsAccess>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3RewardsAccessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns whether the rate is ready, pending, or unavailable. Bands, each with an APY, are included only when it is ready.
 * @summary Get the organization's rewards rate ladder
 */
export const getV3RewardsRate = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<V3RewardsRate>(
      {url: `/v3/rewards/rate`, method: 'GET', signal
    },
      options);
    }




export const getGetV3RewardsRateQueryKey = () => {
    return [
    `/v3/rewards/rate`
    ] as const;
    }


export const getGetV3RewardsRateQueryOptions = <TData = Awaited<ReturnType<typeof getV3RewardsRate>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsRate>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3RewardsRateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3RewardsRate>>> = ({ signal }) => getV3RewardsRate(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsRate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3RewardsRateQueryResult = NonNullable<Awaited<ReturnType<typeof getV3RewardsRate>>>
export type GetV3RewardsRateQueryError = ErrorType<unknown>


export function useGetV3RewardsRate<TData = Awaited<ReturnType<typeof getV3RewardsRate>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsRate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3RewardsRate>>,
          TError,
          Awaited<ReturnType<typeof getV3RewardsRate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3RewardsRate<TData = Awaited<ReturnType<typeof getV3RewardsRate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsRate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3RewardsRate>>,
          TError,
          Awaited<ReturnType<typeof getV3RewardsRate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3RewardsRate<TData = Awaited<ReturnType<typeof getV3RewardsRate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsRate>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the organization's rewards rate ladder
 */

export function useGetV3RewardsRate<TData = Awaited<ReturnType<typeof getV3RewardsRate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsRate>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3RewardsRateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns total paid out, the last payout, and the first payout date across all rewards transactions.
 * @summary Get the organization's rewards payout summary
 */
export const getV3RewardsSummary = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<V3RewardsSummary>(
      {url: `/v3/rewards/summary`, method: 'GET', signal
    },
      options);
    }




export const getGetV3RewardsSummaryQueryKey = () => {
    return [
    `/v3/rewards/summary`
    ] as const;
    }


export const getGetV3RewardsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getV3RewardsSummary>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsSummary>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV3RewardsSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV3RewardsSummary>>> = ({ signal }) => getV3RewardsSummary(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV3RewardsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getV3RewardsSummary>>>
export type GetV3RewardsSummaryQueryError = ErrorType<unknown>


export function useGetV3RewardsSummary<TData = Awaited<ReturnType<typeof getV3RewardsSummary>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3RewardsSummary>>,
          TError,
          Awaited<ReturnType<typeof getV3RewardsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3RewardsSummary<TData = Awaited<ReturnType<typeof getV3RewardsSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV3RewardsSummary>>,
          TError,
          Awaited<ReturnType<typeof getV3RewardsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV3RewardsSummary<TData = Awaited<ReturnType<typeof getV3RewardsSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsSummary>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the organization's rewards payout summary
 */

export function useGetV3RewardsSummary<TData = Awaited<ReturnType<typeof getV3RewardsSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV3RewardsSummary>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV3RewardsSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






